export const ADD_CHILDREN_PROGRESS_COEFFICIENT = 0.42; // Add children percentage part should be equal 30% 30/70=~0.42
export const chunkSize = 5 * 1024 * 1024; // 5 mb
export const SAME_TIME_FILES_UPLOAD_LIMIT = 10;
